enum FunctionKey {
  // Queries
  GET_IS_ADDRESS_AUTHORIZED = 'GET_IS_ADDRESS_AUTHORIZED',
  GET_BLOCK_NUMBER = 'GET_BLOCK_NUMBER',
  GET_VAI_TREASURY_PERCENTAGE = 'GET_VAI_TREASURY_PERCENTAGE',
  GET_PROPORTIONAL_CLOSE_TOLERANCE_PERCENTAGE = 'GET_PROPORTIONAL_CLOSE_TOLERANCE_PERCENTAGE',
  GET_DSA_V_TOKENS = 'GET_DSA_V_TOKENS',
  GET_MARKET_HISTORY = 'GET_MARKET_HISTORY',
  GET_VENUS_VAI_STATE = 'GET_VENUS_VAI_STATE',
  GET_PENDING_REWARDS = 'GET_PENDING_REWARDS',
  GET_TOKEN_ALLOWANCE = 'GET_TOKEN_ALLOWANCE',
  GET_BALANCE_OF = 'GET_BALANCE_OF',
  GET_TOKEN_BALANCES = 'GET_TOKEN_BALANCES',
  GET_VTOKEN_BALANCES = 'GET_VTOKEN_BALANCES',
  GET_MINTABLE_VAI = 'GET_MINTABLE_VAI',
  GET_VENUS_VAI_VAULT_DAILY_RATE = 'GET_VENUS_VAI_VAULT_DAILY_RATE',
  GET_VENUS_VAI_VAULT_RATE = 'GET_VENUS_VAI_VAULT_RATE',
  GET_V_TOKEN_BALANCE = 'GET_V_TOKEN_BALANCE',
  GET_V_TOKEN_BALANCES_ALL = 'GET_V_TOKEN_BALANCES_ALL',
  GET_V_TOKEN_INTEREST_RATE_MODEL = 'GET_V_TOKEN_INTEREST_RATE_MODEL',
  GET_V_TOKEN_APY_SIMULATIONS = 'GET_V_TOKEN_APY_SIMULATIONS',
  GET_V_TOKEN_UTILIZATION_RATE = 'GET_V_TOKEN_UTILIZATION_RATE',
  GET_XVS_VAULT_DAILY_REWARD_TOKENS = 'GET_XVS_VAULT_DAILY_REWARD_TOKENS',
  GET_XVS_VAULT_TOTAL_ALLOCATION_POINTS = 'GET_XVS_VAULT_TOTAL_ALLOCATION_POINTS',
  GET_XVS_VAULT_POOL_INFOS = 'GET_XVS_VAULT_POOL_INFOS',
  GET_XVS_VAULT_USER_INFO = 'GET_XVS_VAULT_USER_INFO',
  GET_XVS_VAULT_PENDING_WITHDRAWALS_FROM_BEFORE_UPGRADE = 'GET_XVS_VAULT_PENDING_WITHDRAWALS_FROM_BEFORE_UPGRADE',
  GET_XVS_VAULT_PENDING_WITHDRAWALS_BALANCE = 'GET_XVS_VAULT_PENDING_WITHDRAWALS_BALANCE',
  GET_XVS_VAULT_POOLS_COUNT = 'GET_XVS_VAULT_POOLS_COUNT',
  GET_XVS_VAULT_WITHDRAWAL_REQUESTS = 'GET_XVS_VAULT_WITHDRAWAL_REQUESTS',
  GET_XVS_VAULT_PAUSED = 'GET_XVS_VAULT_PAUSED',
  GET_CURRENT_VOTES = 'GET_CURRENT_VOTES',
  GET_VOTERS = 'GET_VOTERS',
  GET_PENDING_XVS = 'GET_PENDING_XVS',
  GET_PROPOSALS = 'GET_PROPOSALS',
  GET_PROPOSAL = 'GET_PROPOSAL',
  GET_VOTE_RECEIPT = 'GET_VOTE_RECEIPT',
  GET_VAI_VAULT_USER_INFO = 'GET_VAI_VAULT_USER_INFO',
  GET_VAI_VAULT_PAUSED = 'GET_VAI_VAULT_PAUSED',
  GET_VOTE_DELEGATE_ADDRESS = 'GET_VOTE_DELEGATE_ADDRESS',
  GET_VOTE_SUMMARY = 'GET_VOTE_SUMMARY',
  GET_PROPOSAL_STATE = 'GET_PROPOSAL_STATE',
  GET_LATEST_PROPOSAL_ID_BY_PROPOSER = 'GET_LATEST_PROPOSAL_ID_BY_PROPOSER',
  GET_VOTER_ACCOUNTS = 'GET_VOTER_ACCOUNTS',
  GET_VOTER_DETAILS = 'GET_VOTER_DETAILS',
  GET_VOTER_HISTORY = 'GET_VOTER_HISTORY',
  GET_PROPOSAL_THRESHOLD = 'GET_PROPOSAL_THRESHOLD',
  GET_PROPOSAL_ETA = 'GET_PROPOSAL_ETA',
  GET_PANCAKE_SWAP_PAIRS = 'GET_PANCAKE_SWAP_PAIRS',
  GET_VTOKENS = 'GET_VTOKENS',
  GET_HYPOTHETICAL_PRIME_APYS = 'GET_HYPOTHETICAL_PRIME_APYS',
  GET_IS_USER_PRIME_V2 = 'GET_IS_USER_PRIME_V2',
  GET_PRIME_TOKEN = 'GET_PRIME_TOKEN',
  GET_IS_USER_PRIME = 'GET_IS_USER_PRIME',
  GET_PRIME_STATUS = 'GET_PRIME_STATUS',
  GET_LATEST_APP_VERSION = 'GET_LATEST_APP_VERSION',
  GET_TOKEN_USD_PRICE = 'GET_TOKEN_USD_PRICE',
  GET_PRIME_ESTIMATION = 'GET_PRIME_ESTIMATION',
  GET_PRIME_DISTRIBUTION_FOR_MARKET = 'GET_PRIME_DISTRIBUTION_FOR_MARKET',
  GET_PRIME_LEADERBOARD = 'GET_PRIME_LEADERBOARD',
  GET_PRIME_REWARDS_LEADERBOARD = 'GET_PRIME_REWARDS_LEADERBOARD',
  GET_PRIME_MINIMUM_STAKE = 'GET_PRIME_MINIMUM_STAKE',
  GET_PRIME_TOKEN_LIMIT = 'GET_PRIME_TOKEN_LIMIT',
  GET_PRIME_CURRENT_CYCLE = 'GET_PRIME_CURRENT_CYCLE',
  GET_PRIME_USER_PENDING_REWARDS = 'GET_PRIME_USER_PENDING_REWARDS',
  GET_PRIME_CYCLES = 'GET_PRIME_CYCLES',
  GET_PRIME_CYCLE = 'GET_PRIME_CYCLE',
  GET_PRIME_USER_CYCLE_REWARDS = 'GET_PRIME_USER_CYCLE_REWARDS',
  GET_PRIME_EFFECTIVE_STAKE = 'GET_PRIME_EFFECTIVE_STAKE',
  GET_PRIME_MULTIPLIER_TIERS = 'GET_PRIME_MULTIPLIER_TIERS',
  GET_PRIME_DEPOSITS = 'GET_PRIME_DEPOSITS',
  GET_PRIME_VAULT_CONFIG = 'GET_PRIME_VAULT_CONFIG',
  GET_XVS_BRIDGE_FEE_ESTIMATION = 'GET_XVS_BRIDGE_FEE_ESTIMATION',
  GET_XVS_BRIDGE_STATUS = 'GET_XVS_BRIDGE_STATUS',
  GET_XVS_BRIDGE_MINT_STATUS = 'GET_XVS_BRIDGE_MINT_STATUS',
  GET_POOL_DELEGATE_APPROVAL_STATUS = 'GET_POOL_DELEGATE_APPROVAL_STATUS',
  GET_PROPOSAL_MIN_QUORUM_VOTES = 'GET_PROPOSAL_MIN_QUORUM_VOTES',
  GET_POOL_LIQUIDATION_PENALTY = 'GET_POOL_LIQUIDATION_PENALTY',
  GET_ARE_ISOLATED_POOLS_TIME_BASED = 'GET_ARE_ISOLATED_POOLS_TIME_BASED',
  GET_PAYMASTER_INFO = 'GET_PAYMASTER_INFO',
  GET_POOLS = 'GET_POOLS',
  GET_LIQUIDITY_HUBS = 'GET_LIQUIDITY_HUBS',
  GET_HAS_ISOLATED_POOL_POSITION = 'GET_HAS_ISOLATED_POOL_POSITION',
  GET_LIQUIDITY_HUB = 'GET_LIQUIDITY_HUB',
  GET_LIQUIDITY_HUB_HISTORY = 'GET_LIQUIDITY_HUB_HISTORY',
  GET_ADDRESS_DOMAIN_NAME = 'GET_ADDRESS_DOMAIN_NAME',
  GET_BURNED_BNB = 'GET_BURNED_BNB',
  GET_IMPORTABLE_POSITIONS = 'GET_IMPORTABLE_POSITIONS',
  GET_ACCOUNT_PERFORMANCE_HISTORY = 'GET_ACCOUNT_PERFORMANCE_HISTORY',
  GET_ENABLED_E_MODE_GROUP = 'GET_ENABLED_E_MODE_GROUP',
  GET_ACCOUNT_TRANSACTION_HISTORY = 'GET_ACCOUNT_TRANSACTION_HISTORY',
  GET_SIMULATED_POOL = 'GET_SIMULATED_POOL',
  GET_SWAP_QUOTE = 'GET_SWAP_QUOTE',
  GET_PENDLE_SWAP_QUOTE = 'GET_PENDLE_SWAP_QUOTE',
  GET_IP_LOCATION = 'GET_IP_LOCATION',
  GET_PROPOSAL_COUNT = 'GET_PROPOSAL_COUNT',
  GET_MARKETS_TVL = 'GET_MARKETS_TVL',
  GET_TOP_MARKETS = 'GET_TOP_MARKETS',
  GET_FIXED_RATED_VAULTS = 'GET_FIXED_RATED_VAULTS',
  GET_INSTITUTIONAL_VAULT_USER_DATA = 'GET_INSTITUTIONAL_VAULT_USER_DATA',
  GET_FIXED_RATED_VAULTS_USER_STAKED_TOKENS = 'GET_FIXED_RATED_VAULTS_USER_STAKED_TOKENS',
  GET_INSTITUTIONAL_VAULT_USER_METRICS = 'GET_INSTITUTIONAL_VAULT_USER_METRICS',
  GET_RAW_TRADE_POSITIONS = 'GET_RAW_TRADE_POSITIONS',
  GET_TOKEN_PAIR_K_LINE_CANDLES = 'GET_TOKEN_PAIR_K_LINE_CANDLES',
  GET_TRADE_REDUCE_SWAP_QUOTES = 'GET_TRADE_REDUCE_SWAP_QUOTES',
}

export default FunctionKey;
